import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import { getAis } from '../services/api';
import { AiModel } from '../types';

const Dashboard = () => {
  const [ais, setAis] = useState<AiModel[]>([]);

  useEffect(() => {
    getAis().then((res) => {
      setAis(res.data);
    }).catch((err) => {
      console.error('Error fetching AIs:', err);
    });
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1">
        Welcome! Here are your AIs:
      </Typography>
      <Box sx={{ mt: 2 }}>
        {ais.map((ai) => (
          <Box key={ai.id} sx={{ mb: 1, p: 1, border: '1px solid #ccc', borderRadius: 1 }}>
            <Typography variant="subtitle1">{ai.title} (Version: {ai.currentVersion})</Typography>
            <Typography variant="body2">{ai.description}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Dashboard;
